__turbopack_context__.v({
  "badge": "PortalPersonalViews-module__NiOCmq__badge",
  "compactList": "PortalPersonalViews-module__NiOCmq__compactList",
  "emptyState": "PortalPersonalViews-module__NiOCmq__emptyState",
  "goalRow": "PortalPersonalViews-module__NiOCmq__goalRow",
  "icon": "PortalPersonalViews-module__NiOCmq__icon",
  "intro": "PortalPersonalViews-module__NiOCmq__intro",
  "listCard": "PortalPersonalViews-module__NiOCmq__listCard",
  "mutedBadge": "PortalPersonalViews-module__NiOCmq__mutedBadge",
  "pendingBadge": "PortalPersonalViews-module__NiOCmq__pendingBadge",
  "plainList": "PortalPersonalViews-module__NiOCmq__plainList",
  "profile": "PortalPersonalViews-module__NiOCmq__profile" + " " + __turbopack_context__.i("[project]/apps/client-portal/src/components/PortalDivider.module.css [app-client] (css module)")["before"],
  "profileHeading": "PortalPersonalViews-module__NiOCmq__profileHeading",
  "profiles": "PortalPersonalViews-module__NiOCmq__profiles",
  "programCard": "PortalPersonalViews-module__NiOCmq__programCard",
  "programCopy": "PortalPersonalViews-module__NiOCmq__programCopy",
  "programProgress": "PortalPersonalViews-module__NiOCmq__programProgress",
  "progressComplete": "PortalPersonalViews-module__NiOCmq__progressComplete",
  "progressGroup": "PortalPersonalViews-module__NiOCmq__progressGroup",
  "progressNumber": "PortalPersonalViews-module__NiOCmq__progressNumber",
  "progressTrack": "PortalPersonalViews-module__NiOCmq__progressTrack",
  "resourceName": "PortalPersonalViews-module__NiOCmq__resourceName",
  "rowCopy": "PortalPersonalViews-module__NiOCmq__rowCopy",
  "scheduleDate": "PortalPersonalViews-module__NiOCmq__scheduleDate",
  "scheduleRow": "PortalPersonalViews-module__NiOCmq__scheduleRow",
  "section": "PortalPersonalViews-module__NiOCmq__section" + " " + __turbopack_context__.i("[project]/apps/client-portal/src/components/PortalDivider.module.css [app-client] (css module)")["before"] + " " + __turbopack_context__.i("[project]/apps/client-portal/src/components/PortalDivider.module.css [app-client] (css module)")["band"],
  "sectionHeading": "PortalPersonalViews-module__NiOCmq__sectionHeading",
  "subscriptionCard": "PortalPersonalViews-module__NiOCmq__subscriptionCard",
  "subscriptionDetails": "PortalPersonalViews-module__NiOCmq__subscriptionDetails",
  "subscriptionTop": "PortalPersonalViews-module__NiOCmq__subscriptionTop",
  "subscriptions": "PortalPersonalViews-module__NiOCmq__subscriptions",
  "successBadge": "PortalPersonalViews-module__NiOCmq__successBadge",
  "successIcon": "PortalPersonalViews-module__NiOCmq__successIcon",
  "taskRow": "PortalPersonalViews-module__NiOCmq__taskRow",
  "textLink": "PortalPersonalViews-module__NiOCmq__textLink",
});
